export const dataColorPalette = {
  // blue
  blue_400: '#324FBE',
  blue_300: '#7484CB',
  blue_200: '#A0ABDD',
  blue_100: '#CFD5EE',
  // pink
  pink_400: '#EE6382',
  pink_300: '#F78DA0',
  pink_200: '#FDB4BE',
  pink_100: '#FFD9DE',
  // aqua
  aqua_400: '#15A1C1',
  aqua_300: '#6CB8D0',
  aqua_200: '#A1CFE0',
  aqua_100: '#D1E7EF',
  // magenta
  magenta_400: '#C246AC',
  magenta_300: '#D479C1',
  magenta_200: '#E5A6D5',
  magenta_100: '#F3D2EA',
  // green
  green_400: '#23A68E',
  green_300: '#6ABDA9',
  green_200: '#9ED3C5',
  green_100: '#CFE9E2',
  // gray
  gray_400: '#636985',
  gray_300: '#888CA2',
  gray_200: '#AFB1C0',
  gray_100: '#D6D7DF',
};

/* eslint-disable camelcase */
export type ShadePalette = {
  shade_400: string;
  shade_300: string;
  shade_200: string;
  shade_100: string;
};

export const dataColorRange: ShadePalette[] = [
  {
    shade_400: dataColorPalette.blue_400,
    shade_300: dataColorPalette.blue_300,
    shade_200: dataColorPalette.blue_200,
    shade_100: dataColorPalette.blue_100,
  },
  {
    shade_400: dataColorPalette.pink_400,
    shade_300: dataColorPalette.pink_300,
    shade_200: dataColorPalette.pink_200,
    shade_100: dataColorPalette.pink_100,
  },
  {
    shade_400: dataColorPalette.aqua_400,
    shade_300: dataColorPalette.aqua_300,
    shade_200: dataColorPalette.aqua_200,
    shade_100: dataColorPalette.aqua_100,
  },
  {
    shade_400: dataColorPalette.magenta_400,
    shade_300: dataColorPalette.magenta_300,
    shade_200: dataColorPalette.magenta_200,
    shade_100: dataColorPalette.magenta_100,
  },
  {
    shade_400: dataColorPalette.green_400,
    shade_300: dataColorPalette.green_300,
    shade_200: dataColorPalette.green_200,
    shade_100: dataColorPalette.green_100,
  },
];

export const colorOtherCategory = {
  shade_400: dataColorPalette.gray_400,
  shade_300: dataColorPalette.gray_300,
  shade_200: dataColorPalette.gray_200,
  shade_100: dataColorPalette.gray_100, // <= main shade
};

export const colorOtherCategoryMainShade = colorOtherCategory.shade_100;

const dataColorMainShadeRange = dataColorRange.map((item) => item.shade_400);

export const getColorsRange = (length: number): string[] => {
  return Array.from(
    { length },
    (_, i) => dataColorMainShadeRange[i % dataColorMainShadeRange.length],
  );
};

export const getColorByIndex = (index: number): string => {
  return dataColorMainShadeRange[index % dataColorMainShadeRange.length];
};

export const getShadePaletteByIndex = (index: number): ShadePalette => {
  return dataColorRange[index % dataColorMainShadeRange.length];
};
